import './src/main.css'
import FlylineChart from './src/main.vue'

export default function (Vue) {
  Vue.component(FlylineChart.name, FlylineChart)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/flylineChart/index.js